$(document).foundation();

$(document).ready(function() {
	var $footHeight = $('.footer').height();
	$('.footer-trigger').height($footHeight);
	
	$('#reset-password').on('click', function() {
		$('#sign-in-wrapper').hide();
		$('#reset-wrapper').show();
	});
	
	$('#show-login').on('click', function() {
		$('#sign-in-wrapper').show();
		$('#reset-wrapper').hide();
	});
	
	
	/* delete a case note */
	$('.delete-case-note').click(function(e) {
		var $elem = $(e.currentTarget);
		var $note = $elem.closest('.case-note');
		if (confirm('Are you sure you want to delete this case note?')) {
			$.ajax({
				url: "/ajax/clients/delete-case-note",
				type : "POST",
				contentType : 'application/json',
				data : JSON.stringify({n: $elem.data('note-id')})
			}).done(function() {
				$note.slideUp('fast', function() {
					$(this).remove();
					if (!$('.case-note').length) {
						$('.case-notes').append('<p class="grey14"><em>No notes have been added to this client yet.</em></p>');
					}
				})
			}).fail(function() {
				alert("Sorry, the note could not be deleted. Please check the log for more info")
			});
		} 
	});	
	
	
	
	$('.filter-users-by-office select').change(function() {
		var $this = $(this);
		var $usersSelectHolder = $('.office-filtered-users');
		var $usersSelect = $usersSelectHolder.find('select');
		
		if ($this.val() == '') {
			$usersSelectHolder.addClass('hide');
			$usersSelect.val('');
		} else {
			$usersSelectHolder.removeClass('hide');
			$usersSelect.children('option').each(function() {
				var $elem = $(this);
				if ($elem.data('office-id') != $this.val()) {
					$elem.hide();
				} else {
					$elem.show();
				}
			})
		}
	});
	$('.filter-users-by-office').trigger('change');
	
	
	// clear date button for flatpickers
	$(document).on('click','.clear-date', function() {
		$('#'+$(this).data('for'))[0]._flatpickr.clear();
	});
	
	// set month date pickers
	$('.flatpickr-month-select').each(function() {
		var fp = $(this)[0]._flatpickr;
		fp.destroy();
		$('.flatpickr-month-select').flatpickr({
			altInput: true,
			dateFormat: "Y-m", //defaults to "F Y"
			altFormat: "F Y", //defaults to "F Y"
			plugins: [
				new monthSelectPlugin({
					shorthand: false, //defaults to false
					dateFormat: "Y-m", //defaults to "F Y"
					altFormat: "F Y", //defaults to "F Y"
					theme: "light" // defaults to "light"
				})
			]
		})
	})
	
	// demographics source field
	if ($('.demographics-source-wrapper').length) {
		checkDisplaySourceOther();
	}
	$('.demographics-source-wrapper').find('#source').change(function() {
		checkDisplaySourceOther();
	});
	
	// hide site messages after 5s
	setTimeout(function() {
		$(".messages").slideUp("normal", function() { 
			$(this).remove(); 
		});
	}, 5000);
	
	$('#observationTerm').change(function() {
		observationTermOther();
	})
	
	$('#occupationalStatus').change(function() {
		setLandOccupationStatus();
	})
			
	// stewardship Scheme select box
	$('#stewardshipScheme').change(function() {
		stewardshipSchemeFields();
	});
	
	// SFI
	$('#sfiEnrolled').change(function() {
		sfiFields();
	});

	$('#signpostType').change(function() {
		signpostFields();
	});
	
	
	// Add multiform entity button
	$('.addMultiFormEntry').click(function() {
		$('.no-multi-form-records').hide();
		$('.multi-form-completion').hide();
		$(this).closest('.multi-form-completion').prev('.multi-form-entry').show();
	});
	// End add multiform entity button
	
	/* loanType change */
	$('#loanType').change(function() {
		setLoanType();
	});
	
	/* End loanType change */
	// keep session alive on report entry pages
	if ($('.report-entry').length) {
		setInterval(keepAlive, 300000);
	}
	
	
	// textarea min/max lengths
	$('textarea.field-input').on('input propertychange', function() {
		var $this = $(this);
		var $p = $this.parent().find('.chars-remaining');
		var len = $this.val().length;
		if ($this.data('min-length') && $this.data('max-length')) {
			if (len < $this.data('min-length')) {
				$p.text((parseInt($this.data('min-length')) - len)+' characters required');
			} else {
				if (len > $this.data('max-length')) {
					this.value = this.value.substring(0, $this.data('max-length'));
				}
				len = $this.val().length
				$p.text((parseInt($this.data('max-length')) - len)+' characters remaining');
			}
		} else if ($this.data('min-length')) {
			$p.text((parseInt($this.data('min-length')) - len)+' characters required');
			if (len > $this.data('min-length')) {
				$p.text('0 characters required');
			}
		} else if ($this.data('max-length')) {
			if (len > $this.data('max-length')) {
				this.value = this.value.substring(0, $this.data('max-length'));
			}
			len = $this.val().length
			$p.text((parseInt($this.data('max-length')) - len)+' characters remaining');		 
		}
	});
	
	
	
	
	$('#show-intervention-owner-form').on('click', function(e) {
		$('.set-intervention-owner-form-holder').removeClass('hide');
	})
	
	/**
	* accounts data entry page scripts
	*/
	
	
	if ($('#accounts-fields').length) {
		accountsFieldSummaries();
		
		if ($('#latestYearEnd').val()) {
			$('#accounts-fields').show();
		}
		
		$('#latestYearEnd').change(function() {
			showAccountsFields();
		});
		
		$('#compressedAccounts').change(function() {
			compressAccountsFields();
			accountsFieldSummaries();
		});

		/* Delete accounts field */
		$(document.body).on("click",'a.delete-accounts-field',function() {
			var $this = $(this);
			$this.next('.accounts-category-row').remove();
			$this.remove()
			accountsFieldSummaries();
		});
	
		// Add accounts field
		$('.add-accounts-field').click(function() {
			var numCustomRows = $(this).closest('.accounts-category').find('.accounts-category-row.custom').length;
			var categoryId = $(this).data('category-id');
			var html = '<a class="delete-accounts-field"><i class="fa fa-times" aria-hidden="true"></i></a>'+
				'<div class="accounts-category-row custom grid-x grid-padding-x">'+
				'<div class="cell small-3"><input type="text" name="accounts-'+categoryId+'-custom-'+numCustomRows+'-name" maxlength="45"></div>'+
				'<div class="cell auto"><div class="input-group"><span class="input-group-label">&pound;</span><input type="number" name="accounts-'+categoryId+'-custom-'+numCustomRows+'-1" class="field-input currency-accuracy input-group-field" value="0" autocomplete="nope" required></div></div>'+
				'<div class="cell auto"><div class="input-group"><span class="input-group-label">&pound;</span><input type="number" name="accounts-'+categoryId+'-custom-'+numCustomRows+'-2" class="field-input currency-accuracy input-group-field" value="0" autocomplete="nope" required></div></div>'+
				'<div class="cell auto"><div class="input-group"><span class="input-group-label">&pound;</span><input type="number" name="accounts-'+categoryId+'-custom-'+numCustomRows+'-3" class="field-input currency-accuracy input-group-field" value="0" autocomplete="nope" required></div></div>'+
			'</div>';
			$(html).insertBefore(this)
		});
		
		$('#accounts-fields').on('change keyup','input', function() {
			accountsFieldSummaries();
		})
		
		
	}
	
	// force currency fields to 2 decimal places
	$('.currency-accuracy').val(function(i,v) {
		return parseFloat(v).toFixed(2);
	});
	$(document).on('change','.currency-accuracy', function() {
		if ($(this).val()) {
			$(this).val(parseFloat($(this).val()).toFixed(2));    
		}
	});
	
	// button with class displayForm and data-form data attr for the id of the form/elem to be displayed
	$('.displayForm').on('click', function() {
		var $this = $(this);
		$('#'+$this.data('form')).show();
	})
	
	$(document).on('click', '.item-pos', Foundation.util.throttle(function(e) {
		//$('.item-pos').removeClass('item-pos');
		var $this = $(this);
		updateItemPos($this);
	}, 100));
	
	$('#observation-image').on('change', function(e) {
		imagePreview(e);
		$('#file-trigger').val(1);
	});	
	
	$('.observation-image-preview-wrapper .remove').on('click', function() {
		removeImagePreview();
	});
	
	$('.observation-image-thumb .remove').on('click', function() {
		$('.observation-image-thumb').remove();
		$('#observation-image').parent('.cell').removeClass('hide');
		$('#file-trigger').val(1);
	})
	
	
	// report photos
	$('.num-photo-selector').on('click', function(e) {
		var format = $(e.currentTarget).data('format');
		$('.num-photo-selector').removeClass('selected');
		$(e.currentTarget).addClass('selected');
		$('input:radio[name="numPhotos"][value="'+format+'"]').prop('checked', true);
		reportPhotos(format);
	});
	
	if ($('input:radio[name="numPhotos"]').length) {
		if ($('input[name="numPhotos"]:checked')) {
			var format = $('input[name="numPhotos"]:checked').val();
			format = parseInt(format);
			$('.num-photo-selector[data-format="'+format+'"]').addClass('selected');
			reportPhotos(format);
		}
	}
	
	
	// report photos
	$('.photo-selector').on('click', function(e) {
		$('.photo-page-preview').addClass('hide');
		var photoPageId = $(e.currentTarget).data('photo-page-id');
		$('.photo-selector').removeClass('selected');
		$(e.currentTarget).addClass('selected');
		$('.photo-page-preview[data-photo-page-id="'+photoPageId+'"]').removeClass('hide');
		$
	});
	
	$('.delete-photo-page').on('click', function(e) {
		var $previewWrapper = $(e.currentTarget).parent('.photo-page-preview');
		var photoPageId = $previewWrapper.data('photo-page-id');
		$previewWrapper.addClass('hide');
		$('.photo-selector[data-photo-page-id="'+photoPageId+'"]').parent('div.photo-selector-wrapper').addClass('hide');
		$('#photo-page-trigger-'+photoPageId).val(1);
	});
	
	$('.close-photo-page').on('click', function(e) {
		var $previewWrapper = $(e.currentTarget).parents('.photo-page-preview');
		var photoPageId = $previewWrapper.data('photo-page-id');
		$previewWrapper.addClass('hide');
		$('.photo-selector[data-photo-page-id="'+photoPageId+'"]').removeClass('selected');
	});		
	
	$('.photo-input-wrapper input').on('change', function() {
		var $this = $(this);
		var fileName = $this[0].files[0].name;
		$this.next('label').text(fileName);
		if (fileName.length) {
			$this.siblings('span.clear-file').show();
		}
	});
	
	$('span.clear-file').on('click', function(e) {
		$(e.currentTarget).siblings('input[type="file"]').val('');
		$(e.currentTarget).hide();
		$(e.currentTarget).prev('label').text('Choose file');
	})
	
	$('.delete-report-photos').on('click', function(e) {
		$(e.currentTarget).parent('div.cell').addClass('hide');
		$('.num-photo-selector-wrapper').parent('div.cell').removeClass('hide');
	})
	
	$('.add-new-photo-page').on('click', function(e) {
		$('.photo-page-form').removeClass('hide');
		$('.multi-form-completion').addClass('hide');
		if ($('.report-form-completion').length) {
			$('.report-form-completion').addClass('hide');
		}
		if ($('.report-content-items-wrapper').length) {
			$('.report-content-items-wrapper').addClass('hide');
		}
	})
	
	// end report photos
	
	// report content
	
	$('.add-report-content-buttons .button').on('click', function(e) {
		var contentType = $(e.currentTarget).data('content-type');
		var $form = $('.add-report-content-form');
		$form.addClass('active');
		$form.find('#add-report-content-form-content-type').val(contentType);
		$('.report-content-field').each(function(i) {
			var $inputHolder = $(this);
			if ($inputHolder.hasClass(contentType)) {
				$inputHolder.show();
				$inputHolder.find('.field-input').prop('required', true);
			} else {
				$inputHolder.find('.field-input').prop('required', false);
				$inputHolder.hide();
			}
		})
		$('.multi-form-completion, .add-report-content-buttons').addClass('hide');
	});
	
	var addReportContentFormsubmitting = false;
	$('.add-report-content-form').submit(function(e) {
		e.preventDefault();
		if (!addReportContentFormsubmitting) {
			addReportContentFormsubmitting = true;
			var $form = $(this);
			var $submitButton = $form.find('button.save');
			var data = $form.serializeObject();
			data.csrf = $('.report-content-items-wrapper').data('token')
			$.ajax({
				url: '/ajax/clients/report/add-report-content',
				type: "POST",
				contentType: 'application/json',
				data : JSON.stringify(data),
				beforeSend: function() {
					$submitButton.attr('type', 'button').html('<i class="fas fa-spinner fa-spin"></i>');
				}
			}).done(function(response) {
				$('.report-content-items-wrapper').append(response.html);
				addReportContentFormsubmitting = false;
				$submitButton.attr('type', 'submit').html('<i class="fa-solid fa-check"></i>');
				$form.removeClass('active');
				$form.find('.field-input').val('');
				$('.multi-form-completion, .add-report-content-buttons').removeClass('hide');
			}).fail(function() {
				addReportContentFormsubmitting = false;
				$submitButton.attr('type', 'submit').html('<i class="fa-solid fa-check"></i>');
				alert('Sorry, the content could not be saved due to an error.');
			})
		}
	});
	
	$('.add-report-content-form').on('click','.button.cancel',function() {
		var $form = $('.add-report-content-form');
		var contentType = $('#add-report-content-form-content-type').val();
		var unsavedContent = false;
		$('.report-content-field').each(function() {
			var $inputHolder = $(this);
			if ($inputHolder.hasClass(contentType) && $inputHolder.find('.field-input').val()) {
				unsavedContent = true;
			}
		});
		
		if(!unsavedContent || confirm("Are you sure you want to delete the unsaved content?")) {
			$form.removeClass('active');
			$('#add-report-content-form-content-type, .report-content-field .field-input').val('');
			$('.multi-form-completion, .add-report-content-buttons').removeClass('hide');
		}
		
	})
	
	$(document).on('click', '.edit-report-content', function(e) {
		var $contentItem = $(e.currentTarget).closest('.report-content-item');
		$contentItem.addClass('editing');
		var contentType;
		if ($contentItem.hasClass('type-bullet')) {
			contentType = 'bullet';
		} else if ($contentItem.hasClass('type-text')) {
			contentType = 'text';
		} else {
			contentType = 'title';
		}
		var content = $contentItem.find('.report-content').text();
		var $form = $contentItem.find('form.report-content-edit-form');
		var formHtml;
		formHtml = '<div class="cell auto grid-x grid-padding-x">'+
			'<div class="cell report-content-field small-12">';
				switch(contentType) {
					case 'title':
						formHtml = formHtml + '<label class="field-label" for="add-report-content-form-text"><span class="mandatory">*</span>Title</label>'+
						'<input id="add-report-content-form-title" type="text" name="content" class="field-input" autocomplete="nope" required value="'+content.replace(/"/g, '&quot;')+'">';
					break;
					case 'text':
						formHtml = formHtml + '<label class="field-label" for="add-report-content-form-text"><span class="mandatory">*</span>Text</label>'+
						'<textarea name="content" class="field-input" autocomplete="nope" rows="5" required>'+content.replace(/"/g, '&quot;')+'</textarea>';
					break;
					case 'bullet':
						formHtml = formHtml + '<label class="field-label" for="add-report-content-form-text"><span class="mandatory">*</span>Bullet point</label>'+
						'<textarea name="content" class="field-input" autocomplete="nope" rows="5" required>'+content.replace(/"/g, '&quot;')+'</textarea>';
					break;
				}
			formHtml = formHtml + '</div>'+
		'</div>'+
		'<div class="cell shrink">'+
			'<label>&nbsp;</label>'+
			'<button type="button" class="button clear alert float-right cancel"><i class="fa-solid fa-times"></i></button>'+
			'<button type="submit" class="button float-right save"><i class="fa-solid fa-check"></i></button>'+
		'</div>';
		$form.html(formHtml);
		// add the original content as a data attribute so we can check if it's been edited on cancel
		$form.find('.field-input').data('content',content.replace(/"/g, '&quot;'));
	});
	
	$(document).on('click','.report-content-edit-form button.cancel', function(e) {
		var $contentItem = $(e.currentTarget).closest('.report-content-item');
		var $form = $contentItem.find('form.report-content-edit-form');
		var $contentElem = $form.find('.field-input');
		if ($contentElem.val() == $contentElem.data('content') || confirm("Are you sure you want to revert this content item back to its previous value?")) {
			$contentItem.removeClass('editing');
			$form.empty();
		}
	});
	
	$(document).on('submit','.report-content-edit-form', function(e) {
		e.preventDefault();
		var $form = $(this);
		var $submitButton = $form.find('button.save');
		var $cancelButton = $form.find('button.cancel');
		var $contentItem = $form.closest('.report-content-item');
		var content = $form.find('.field-input').val();
		var data = {
			csrf: $contentItem.closest('.report-content-items-wrapper').data('token'),
			reportContentId: $contentItem.data('report-content-id'),
			content: content
		};
		$.ajax({
			url: '/ajax/clients/report/update-report-content',
			type: "POST",
			contentType: 'application/json',
			data : JSON.stringify(data),
			beforeSend: function() {
				$submitButton.attr('type', 'button').html('<i class="fas fa-spinner fa-spin"></i>');
				$cancelButton.removeClass('cancel');
			}
		}).done(function() {
			$contentItem.find('.report-content').html(content.replace(/(?:\r\n|\r|\n)/g, '<br>'));
			$contentItem.removeClass('editing');
			$form.empty();
		}).fail(function(response) {
			$submitButton.attr('type', 'submit').html('<i class="fa-solid fa-check"></i>');
			$cancelButton.addClass('cancel');
			alert(response.responseJSON.error);
		})
		
	});
	
	$(document).on('click', '.delete-report-content', function(e) {
		var $deleteButton = $(e.currentTarget);
		var $contentItem = $deleteButton.closest('.report-content-item');
		if (confirm("Are you sure you want to remove this content item?")) {
			var data = {
				csrf: $contentItem.closest('.report-content-items-wrapper').data('token'),
				reportContentId: $contentItem.data('report-content-id'),
				interventionId: $contentItem.closest('.report-entry').data('intervention-id')
			};
			$.ajax({
				url: '/ajax/clients/report/delete-report-content',
				type: "POST",
				contentType: 'application/json',
				data : JSON.stringify(data),
				beforeSend: function() {
					$deleteButton.html('<i class="fas fa-spinner fa-spin"></i>');
				}
			}).done(function() {
				$contentItem.slideUp('fast',function() {
					$(this).remove();
				});
			}).fail(function(response) {
				$deleteButton.html('<i class="fa-solid fa-trash-can"></i>');
				alert(response.responseJSON.error);
			})
		}
	});
	
	// end report content
	
	
	
	
	$('.table-filter, reporting-section-filter').find('input').keydown(function(event){
		if(event.keyCode == 13) {
			event.preventDefault();
			return false;
		}
	});
	
	$('.photo-pos').on('click', Foundation.util.throttle(function(e) {
		//$('.photo-pos').removeClass('photo-pos');
		var $elem = $(e.currentTarget);
		updatePhotoPos($elem);
	}, 100));
	
	if ($('.sfi-scheme-code-form').length) {
		var $form = $('.sfi-scheme-code-form');
		$form.submit(function(e) {
			if ($form.find('input.submit').hasClass('disabled')) {
				e.preventDefault();
			}
		});
		$form.on('change keyup','#sfiCode, #sfiSchemeYear', function(e) {
			var $elem = $('#sfiCode');
			var $codeErrors = $form.find('.code-errors');
			var code = $elem.val()
			
			var yearId = $('#sfiSchemeYear').val();
			
			var $submitButton = $form.find('input.submit');
			if (code == '' || yearId === '' || !Number.isInteger(Number(yearId))) {
				$codeErrors.addClass('hide').empty();
				$submitButton.removeClass('disabled');
			} else {
				$codeErrors.find('i').remove();
				$codeErrors.append('<i class="fas fa-spinner fa-spin"></i>');
				$.ajax({
					url: "/ajax/library/check-new-sfi-scheme-code",
					type : "POST",
					contentType : 'application/json',
					data: JSON.stringify({
						code: code,
						year: yearId
					})
				}).done(function(response) {
					if (response.valid) {
						$codeErrors.addClass('hide').empty();
						$submitButton.removeClass('disabled');
					} else {
						$codeErrors.removeClass('hide').html(response.message);
						$submitButton.addClass('disabled');
					}
				}).fail(function() {
					$codeErrors.removeClass('hide').html('Unable to check code validity, please check the error log.');
					$submitButton.removeClass('disabled');
				});
			}
		});
		$form.on('change','#sfi-scheme-unit, #sfi-scheme-apply-addition',function() {
			setSfiSchemeCodeFormFields();
		});
		setSfiSchemeCodeFormFields();
	}
	
	if ($('#ffr-metrics-summaries').length && $('#ffr-metrics-filter').length) {
		var $filterForm = $('#ffr-metrics-filter');
		var $metricsContainer = $('#ffr-metrics-summaries');
		$filterForm.on('change', 'select', function() {
			displayFFRMetricsSummary($metricsContainer, $filterForm);
		})
		displayFFRMetricsSummary($metricsContainer, $filterForm);
	}
	
});


function displayFFRMetricsSummary($metricsContainer, $filterForm) {
	var data = $filterForm.serializeObject();
	var $metrics = $metricsContainer.find('.metrics');
	$metrics.empty();
	$metricsContainer.addClass('fade-out-load');
	$.ajax({
		url: "/ajax/reporting/ffr-metrics-summary",
		type : "POST",
		contentType : 'application/json',
		data: JSON.stringify(data)
	}).done(function(response) {
		$metricsContainer.removeClass('fade-out-load');
		$metrics.html(response.html);
	}).fail(function() {
		$metricsContainer.removeClass('fade-out-load');
		$metrics.html('unable to load metrics data');
	});
}


function bindMapInfoWindow(marker, map, infowindow, strDescription) {
	google.maps.event.addListener(marker, 'click', function() {
		infowindow.setContent(strDescription);
		infowindow.open(map, marker);
	});
}

function showAccountsFields() {
	var d = $('#latestYearEnd').val()
	if (d) {
		$('#accounts-fields').show();
		var date = new Date(d);
		var day = date.getDate();
		var month = date.getMonth() + 1; //Months are zero based
		var year = date.getFullYear();
		if (day < 10) {
			day = '0'+day;
		}
		if (month < 10) {
			month = '0'+month;
		}
		var dateStr1 = day+'/'+month+'/'+year;
		var dateStr2 = day+'/'+month+'/'+(year-1);
		var dateStr3 = day+'/'+month+'/'+(year-2);
		$('#year1-fields').text(dateStr1);
		$('#year2-fields').text(dateStr2);
		$('#year3-fields').text(dateStr3);
	}
}

function compressAccountsFields() {
	var compressed = $('#compressedAccounts').prop('checked');
	$('.accounts-category.compressible').find('input').prop('required',!compressed)
	$('.accounts-category.compressible .accounts-summary-row').find('input').prop('required',compressed)
	if (compressed) {
		$('.accounts-category.compressible .accounts-category-row').slideUp();
		$('.accounts-category.compressible .accounts-summary-row').slideDown();
		$('.accounts-category.compressible .accounts-total-row').slideUp();
		$('.accounts-category.compressible .add-accounts-field').slideUp();
	} else {
		$('.accounts-category.compressible .accounts-category-row').slideDown();
		$('.accounts-category.compressible .accounts-summary-row').slideUp();
		$('.accounts-category.compressible .accounts-total-row').slideDown();
		$('.accounts-category.compressible .add-accounts-field').slideDown();
	}
}

function checkDisplaySourceOther() {
	var selectedVal = $("#source option:selected").text();
	switch (selectedVal) {
		case 'Advertisement / Editorial':
			setFieldLabel('sourceOther', 'Publication');
			showFieldHolder('sourceOther',true);
		break;
		case 'Brown & Co Show / Seminar':
			setFieldLabel('sourceOther', 'Name of Show / Seminar');
			showFieldHolder('sourceOther',true);
		break;
		case 'Brown & Co Social Media':
			setFieldLabel('sourceOther', 'Social Media Platform');
			showFieldHolder('sourceOther',true);
		break;
		case 'Received letter / email / mailshot from Brown & Co':
			setFieldLabel('sourceOther', 'Date & source of correspondence');
			showFieldHolder('sourceOther',true);
		break;
		case 'Referred by bank / solicitor / accountant':
			setFieldLabel('sourceOther', 'Name of introducing firm');
			showFieldHolder('sourceOther',true);
		break;
		case 'Referred by another farmer / contact':
			setFieldLabel('sourceOther', 'Name of introducer');
			showFieldHolder('sourceOther',true);
		break;
		case 'Other':
			setFieldLabel('sourceOther', 'Please give details');
			showFieldHolder('sourceOther',true);
		break;
		default:
			hideFieldHolder('sourceOther');
		break;
	}
}

function stewardshipSchemeFields() {
	var selectedVal = $("#stewardshipScheme option:selected").text();
		switch (selectedVal) {
		case 'ELS':
		case 'HLS':
		case 'CSS':
			showFieldHolder('lastStewardshipPayment',true);
			showFieldHolder('stewardshipExpiry',true);
		break;
		default:
			hideFieldHolder('lastStewardshipPayment');
			hideFieldHolder('stewardshipExpiry');
		break;
	}
}

function sfiFields() {
	if ($('#sfiEnrolled').is(':checked') == true) {
		showFieldHolder('sfiAnnualPayment', true);
		showFieldHolder('sfiExpiry', true);
	} else if($('#sfiEnrolled').is(':checked') == false) {
		hideFieldHolder('sfiAnnualPayment');
		hideFieldHolder('sfiExpiry');
	}
}

function hideFieldHolder(fieldId) {
	$('#'+fieldId).prop('required',false);
	$('#'+fieldId).closest('.cell').slideUp('fast');
	if ($('#'+fieldId).siblings('label').length) {
		$('#'+fieldId).prevAll('label').children().remove('span.mandatory');
	} else {
		$('#'+fieldId).closest('.input-group').prev('label').children().remove('span.mandatory');
		//$('#'+fieldId).closest('label').children().remove('span.mandatory');
	}
}

function showFieldHolder(fieldId, mandatory) {
	if (mandatory) {
		$('#'+fieldId).prop('required',true);
		if ($('#'+fieldId).siblings('label').length) {
			$('#'+fieldId).prev('label').prepend('<span class="mandatory">*</span>');
		} else {
			$('#'+fieldId).closest('.input-group').prev('label').prepend('<span class="mandatory">*</span>');
			//$('#'+fieldId).closest('label').prepend('<span class="mandatory">*</span>');
		}
	}
	$('#'+fieldId).closest('.cell').removeClass('hide');
	$('#'+fieldId).closest('.cell').slideDown('fast');
}
function setFieldLabel(fieldId,labelText) {
	$('#'+fieldId).prevAll('label').text(labelText);
}

function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

function observationTermOther() {
	var selectedVal = $('#observationTerm option:selected').text();
	if (selectedVal == 'Other') {
		showFieldHolder('termOther', true);
	} else {
		hideFieldHolder('termOther');
	}
}

function setLandOccupationStatus() {
	var selectedVal = $("#occupationalStatus option:selected").text();
	switch (selectedVal) {
		case 'Owned':
		case 'Please select...':
			hideFieldHolder('term');
			hideFieldHolder('rent');
			hideFieldHolder('expiryDate');
		break;
		case 'AHA':
			hideFieldHolder('term');
			showFieldHolder('rent',true);
			hideFieldHolder('expiryDate');
		break;
		case 'COA':
		case 'CFA':
			showFieldHolder('term',true);
			hideFieldHolder('rent');
			showFieldHolder('expiryDate',false);
		break;
		case 'Informal Arrangement':
			hideFieldHolder('term');
			hideFieldHolder('rent');
			hideFieldHolder('expiryDate');
		break;
		default:
			showFieldHolder('term',true);
			showFieldHolder('rent',true);
			showFieldHolder('expiryDate',false);
		break;
	}
}

function setLoanType() {
	var selectedVal = $("#loanType option:selected").text();
	switch (selectedVal) {
		case 'Mortgage':
		case 'Term Loan':
			showFieldHolder('loanEndDate');
		break;
		default:
			hideFieldHolder('loanEndDate');
		break;
	}
}

function keepAlive() {
	$.ajax({
		url: "/ajax/keep-alive",
		type : "GET",
		contentType : 'application/json',
	}).done(function() {
		//console.log("Session kept alive")
	}).fail(function() {
		alert('We were unable to keep your session alive, please make sure you save your work frequently');
	});
}

function accountsFieldSummaries() {
	
	var compressed = $('#compressedAccounts').prop('checked');
	
	$('.accounts-category-total').each(function() {
		var $totalElem = $(this);
		var yearIndex = $totalElem.parent().index();
		var total = 0;
		$totalElem.closest('.accounts-category').find('.accounts-category-row').each(function(i,v) {
			
		if ($.isNumeric(parseFloat($(v).children().eq(yearIndex).find('input').val()))) {
			total += parseFloat($(v).children().eq(yearIndex).find('input').val());
		}			
			
		});
		$totalElem.html('&pound;'+numberWithCommas(total));
	});
	
	$('.gross-profit').each(function() {
		var grossProfitElem = $(this);
		var yearIndex = grossProfitElem.parent().index();
		var output = 0;
		var costOfSales = 0;
		var fixedCosts = 0;
		$('.accounts-category[data-category-name="Output"]').find('.accounts-category-row').each(function(i,v) {
			if ($.isNumeric(parseFloat($(v).children().eq(yearIndex).find('input').val()))) {
				output += parseFloat($(v).children().eq(yearIndex).find('input').val());
			}
		});
		if (compressed) {
			costOfSales = $('.accounts-category[data-category-name="Cost of Sales"] .accounts-summary-row').children().eq(yearIndex).find('input').val();
			fixedCosts = $('.accounts-category[data-category-name="Fixed Costs"] .accounts-summary-row').children().eq(yearIndex).find('input').val();
		} else {
			$('.accounts-category[data-category-name="Cost of Sales"]').find('.accounts-category-row').each(function(i,v) {
				if ($.isNumeric(parseFloat($(v).children().eq(yearIndex).find('input').val()))) {
					costOfSales += parseFloat($(v).children().eq(yearIndex).find('input').val());
				}
			});
			$('.accounts-category[data-category-name="Fixed Costs"]').find('.accounts-category-row').each(function(i,v) {
				if ($.isNumeric(parseFloat($(v).children().eq(yearIndex).find('input').val()))) {
					fixedCosts += parseFloat($(v).children().eq(yearIndex).find('input').val());					
				}
			});
		}
		var grossProfit = output - costOfSales;
		var netProfit = grossProfit - fixedCosts;
		grossProfitElem.html((grossProfit<0?'(':'')+'&pound;'+numberWithCommas(Math.abs(grossProfit))+(grossProfit<0?')':''));
		$('.net-profit').eq(yearIndex-1).html((netProfit<0?'(':'')+'&pound;'+numberWithCommas(Math.abs(netProfit))+(netProfit<0?')':''));
	});
	
	$('.net-assets').each(function() {		
		var $this = $(this);
		var yearIndex = $this.parent().index();
		var netAsset = 0;
		
		$('.accounts-category').each(function(i) {
			var $ac = $(this);
			var temp;
			if (compressed) {
				temp = $ac.find('.accounts-summary-row').children('.cell').eq(yearIndex).find('input').val();
			} else {
				temp = $ac.find('.accounts-total-row').children('.total').eq(yearIndex-1).children('span').text();				
			}
			var price = parseFloat(temp.toString().replace(/[^0-9\.]/g, ''));
			if (i < 2) {
				netAsset += price;
			} else {
				netAsset -= price;
			}
		})
		
		$this.html('&pound;'+numberWithCommas(netAsset));
		
	})
	
}

function signpostFields() {	
	var selectedVal = $("#signpostType option:selected").val();
	switch (selectedVal) {
		case '0':
			showFieldHolder('librarySignpost', true);
			hideFieldHolder('user');
			hideFieldHolder('customName');
			hideFieldHolder('customOrganisation');
			hideFieldHolder('customTelephone');
			hideFieldHolder('customEmail');
		break;
		case '1':
			showFieldHolder('user', true);
			hideFieldHolder('customName');
			hideFieldHolder('customOrganisation');
			hideFieldHolder('customTelephone');
			hideFieldHolder('customEmail');
			hideFieldHolder('librarySignpost');
		break;
		case '2':
			showFieldHolder('customName');
			showFieldHolder('customOrganisation', true);
			showFieldHolder('customTelephone');
			showFieldHolder('customEmail');
			hideFieldHolder('user');
			hideFieldHolder('librarySignpost');
		break;
	}
}

function updateItemPos($elem) {
	var data = {
		item: $elem.data('item'),
		itemId: $elem.data('item-id'),
		direction: $elem.data('direction')
	}
	var $parent = $elem.closest('.report-content-item');
	
	$.ajax({
		url: '/ajax/clients/report/update-report-item-position',
		type: "POST",
		contentType: 'application/json',
		data : JSON.stringify(data),
		beforeSend: function() {
			$elem.html('<i class="fas fa-spinner fa-spin"></i>')
		}
	}).done(function() {
		//location.reload();
		
		if ($parent.length) {				
			if (data.direction == 1) {
				$parent.insertAfter($parent.next());
				$elem.html('<i class="fa-solid fa-chevron-down"></i>')
			} else {
				$parent.insertBefore($parent.prev());
				$elem.html('<i class="fa-solid fa-chevron-up"></i>')
			}	
			
		} else {
			location.reload();
		}
	}).fail(function() {
		if ($parent.length) {				
			if (data.direction == 1) {
				$elem.html('<i class="fa-solid fa-chevron-down"></i>')
			} else {
				$elem.html('<i class="fa-solid fa-chevron-up"></i>')
			}	
		}
		alert('Unable to change position');
	})
}

function imagePreview(e) {
	if (! e.target.files.length) {
		alert("Error!");
		return;
	}
	var $observationImagePreview = $('#observation-image-preview');
	$observationImagePreview.empty();
	
	var imageurl = URL.createObjectURL(e.target.files[0]);
	// For testing purposes, I set the width to 150px.
	var $image = '<img src=' + imageurl + ' width="150">';
	$observationImagePreview.append($image);
	
	var aspectRatio = 100*($image.height/$image.width);
	$('#full-size-modal').empty();
	var $modalContent = '<img src="'+ imageurl +'" style="width:100%;padding-bottom:'+aspectRatio+'%;">'
	$('#full-size-modal').append($modalContent);
	
	$('.observation-image-preview-wrapper').show();
	
}

function removeImagePreview() {
	$('.observation-image-preview-wrapper').hide();
	$('#observation-image-preview').empty();
	$('#full-size-modal').empty();
	$('#observation-image').val('');
}

function reportPhotos(format) {
	var fileInputs = {
		0 : $('input[name="photo[0]"]'),
		1 : $('input[name="photo[1]"]'),
		2 : $('input[name="photo[2]"]'),
		3 : $('input[name="photo[3]"]')
	};
	var imageCaptions = {
		0 : $('input[name="photoCaption-0"]'),
		1 : $('input[name="photoCaption-1"]'),
		2 : $('input[name="photoCaption-2"]'),
		3 : $('input[name="photoCaption-3"]')
	};
	
	$.each(fileInputs, function (i, currElem) {
		currElem.parent('.cell').addClass('hide');
	});
	
	$.each(imageCaptions, function (i, currElem) {
		currElem.parent('.cell').addClass('hide');
	});
	
	if (format === 1) {
		fileInputs[0].parent('.cell').removeClass('hide');	
		imageCaptions[0].parent('.cell').removeClass('hide');	
		fileInputs[0].prop('required', true);	
		fileInputs[1].val('');
		fileInputs[1].prop('required', false);	
		imageCaptions[1].val('');
		fileInputs[2].val('');
		fileInputs[2].prop('required', false);	
		imageCaptions[2].val('');
		fileInputs[3].val('');
		fileInputs[3].prop('required', false);
		imageCaptions[3].val('');	
	} else if (format === 2) {
		fileInputs[0].parent('.cell').removeClass('hide');	
		imageCaptions[0].parent('.cell').removeClass('hide');	
		fileInputs[0].prop('required', true);	
		fileInputs[1].parent('.cell').removeClass('hide');	
		imageCaptions[1].parent('.cell').removeClass('hide');	
		fileInputs[1].prop('required', true);	
		fileInputs[2].val('');
		fileInputs[2].prop('required', false);
		imageCaptions[2].val('');
		fileInputs[3].val('');
		fileInputs[3].prop('required', false);
		imageCaptions[3].val('');
	} else if (format === 4) {
		fileInputs[0].parent('.cell').removeClass('hide');	
		imageCaptions[0].parent('.cell').removeClass('hide');	
		fileInputs[0].prop('required', true);	
		fileInputs[1].parent('.cell').removeClass('hide');
		imageCaptions[1].parent('.cell').removeClass('hide');		
		fileInputs[1].prop('required', true);	
		fileInputs[2].parent('.cell').removeClass('hide');
		imageCaptions[2].parent('.cell').removeClass('hide');	
		fileInputs[2].prop('required', true);		
		fileInputs[3].parent('.cell').removeClass('hide');	
		imageCaptions[3].parent('.cell').removeClass('hide');	
		fileInputs[3].prop('required', true);	
	} else if (format === 0) {	
		fileInputs[0].val('');
		fileInputs[0].prop('required', false);	
		imageCaptions[0].val('');
		fileInputs[1].val('');
		fileInputs[1].prop('required', false);	
		imageCaptions[1].val('');
		fileInputs[2].val('');
		fileInputs[2].prop('required', false);	
		imageCaptions[2].val('');
		fileInputs[3].val('');
		fileInputs[3].prop('required', false);	
		imageCaptions[3].val('');
	}
}

// photo pages positioning
function updatePhotoPos($elem) {
	var data = {
		photoPageId: $elem.data('photo-page-id'),
		subSectionId: $elem.closest('.report-entry').data('subsection-id'),
		direction: $elem.data('direction')
	}
	var $parent = $elem.closest('.photo-selector-wrapper');
	
	$.ajax({
		url: '/ajax/clients/report/update-photo-page-position',
		type: "POST",
		contentType: 'application/json',
		data : JSON.stringify(data),
		beforeSend: function() {
			$elem.html('<i class="fas fa-spinner fa-spin"></i>')
		}
	}).done(function() {
		
		if ($parent.length) {				
			if (data.direction == 1) {
				$parent.insertAfter($parent.next());
				$elem.html('<i class="fa-solid fa-chevron-right"></i>')
			} else {
				$parent.insertBefore($parent.prev());
				$elem.html('<i class="fa-solid fa-chevron-left"></i>')
			}
			
		} else {
			location.reload();
		}
	}).fail(function() {
		if ($parent.length) {				
			if (data.direction == 1) {
				$elem.html('<i class="fa-solid fa-chevron-down"></i>')
			} else {
				$elem.html('<i class="fa-solid fa-chevron-up"></i>')
			}	
		}
		alert('Unable to change position');
	})
}


// function to make form values to json format
$.fn.serializeObject = function() {
	var o = {};
	var a = this.serializeArray();
	$.each(a, function() {
		if (o[this.name] !== undefined) {
			if (!o[this.name].push) {
				o[this.name] = [o[this.name]];
			}
			o[this.name].push(this.value || '');
		} else {
			o[this.name] = this.value || '';
		}
	});
	return o;
};

// Initialize and add the map
function initMap() {
  // The location of Uluru
  const uluru = { lat: -25.344, lng: 131.031 };
  // The map, centered at Uluru
  const map = new google.maps.Map(document.getElementById("map"), {
    zoom: 4,
    center: uluru,
  });
  // The marker, positioned at Uluru
  const marker = new google.maps.Marker({
    position: uluru,
    map: map,
  });
}

window.initMap = initMap;